import { render, staticRenderFns } from "./Taobao-dis-item.vue?vue&type=template&id=0513f45a&"
import script from "./Taobao-dis-item.vue?vue&type=script&lang=js&"
export * from "./Taobao-dis-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports